module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-thank-you"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "pages-thank-you-wrap"
  }, [_c('div', {
    staticClass: "pages-thank-you_inner"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v("Thank you for contacting us.")]), _c('p', [_vm._v("We will contact you as soon as we review your message.")]), _c('router-link', {
    staticClass: "pages-thank-you-back-btn",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Return to Homepage     ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-662543cc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/thank-you/thank-you.pug
// module id = 538
// module chunks = 1